import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "../css/Login.styles";
import Swal from "sweetalert2";
import { useRecoilState } from "recoil";
import { loginState } from "../stores/loginState";
import { useGetLogin } from "../api/useGetLogin";
import useGetNVRLogin from "../api/useGetNVRLogin";

function Login() {
  
  // NOTE 아이디, 비밀번호, 고객사, ID저장 여부 등 변수 선언
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [isShowPassword, setIsShowPassword] = useState({
    type: "password",
    isShow: false,
  });
  const [isSelectBoxOpen, setIsSelectBoxOpen] = useState(false);
  const [login, setLogin] = useRecoilState(loginState);

  const selectBoxOutside = useRef(null);

  const navigate = useNavigate();
    
  // 현재 URL 가져오기
  const currentUrl = window.location.href;

  // URLSearchParams를 사용하여 쿼리 파라미터 파싱
  const urlParams = new URLSearchParams(new URL(currentUrl).search);

  // TODO 로그인 API 호출
  const { mutate: loginMutate } = useGetLogin(
    id,
    password
  );

  // TODO NVR에서 로그인 시도 시
  const { mutate: loginNvr } = useGetNVRLogin(urlParams.get("key"));

  // NOTE NVR 자동로그인 시도 감지
  useEffect(() => {

    if (urlParams.get("key")) {
      loginNvr();
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // NOTE 로그인 정보가 저장되어 있는 경우 메인 페이지로 이동
  useEffect(() => {
    if (login.isLogin) {
      navigate("/Dashboard");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login.isLogin, navigate]);

  // NOTE 아이디 기억하기 계정인 경우 login state에서 id set해주기
  useEffect(() => {
    if (login.isUserIdStored && login.userId) {
      setId(login.userId);
    }
  }, [login.isUserIdStored, login.userId]);

  // NOTE 비밀번호 표시 여부
  const onClickPasswordIcon = () => {
    if (!isShowPassword.isShow)
      setIsShowPassword({
        type: "string",
        isShow: true,
      });
    else
      setIsShowPassword({
        type: "password",
        isShow: false,
      });
  };

  // NOTE 택배사 리스트 보여주기
  const onClickSelectBox = (e) => {
    e.stopPropagation();
    setIsSelectBoxOpen(!isSelectBoxOpen);
  };

  // 택배사 선택 시
  const handleCompany = (company) => {
    setLogin({ ...login, company });
  };

  // NOTE ID 저장 함수
  const handleCheckbox = (e) => {
    if (e.target.checked) {
      setLogin({ ...login, isUserIdStored: e.target.checked, userId: id });
    } else {
      setLogin({ ...login, isUserIdStored: e.target.checked });
    }
  };

  // NOTE 로그인 함수
  const onClickLogin = () => {
    // 택배사 선택이 되어있지 않을 시
    if (!login.company) {
      Swal.fire({
        icon: "warning",
        title: "택배사를 선택해주세요.",
        confirmButtonText: "확인",
      });
      return;
    }
    // 로그인 함수 호출
    loginMutate();
  };

  // NOTE 엔터 키 누르면 로그인 시도
  const handleKeyDownEnter = (e) => {
    if (e.key === "Enter") {
      onClickLogin();
    }
  };
  return (
    <S.Container onKeyDown={handleKeyDownEnter}>
      <S.LoginContainer>
        <S.LogoContainer>
          <img src="icon_vass.png" style={{ height: "120px" }} alt="logo" />
        </S.LogoContainer>

        <S.InputContainer>
          <S.SelectBox
            ref={selectBoxOutside}
            $isSelectBoxOpen={isSelectBoxOpen}
            onClick={onClickSelectBox}
          >
            <p>{login.company || "택배사 선택"}</p>
            {isSelectBoxOpen ? <S.ArrowUp /> : <S.ArrowDown />}

            {isSelectBoxOpen && (
              <S.OptionContainer $isSelectBoxOpen={isSelectBoxOpen}>
                <S.Option onClick={() => handleCompany("LOGEN")}>
                  LOGEN
                </S.Option>
                <S.Option onClick={() => handleCompany("LOTTE")}>
                  LOTTE
                </S.Option>
                <S.Option onClick={() => handleCompany("HANJIN")}>
                  HANJIN
                </S.Option>
                <S.Option onClick={() => handleCompany("HANDEX")}>
                  HANDEX
                </S.Option>
              </S.OptionContainer>
            )}
          </S.SelectBox>
          <S.Input
            placeholder="점소코드를 입력해주세요."
            onChange={(e) => setId(e.target.value)}
            defaultValue={login.userId}
            maxLength={8}
          />
          <S.PasswordContainer>
            <S.Input
              type={isShowPassword.type}
              placeholder="비밀번호를 입력해주세요."
              onChange={(e) => setPassword(e.target.value)}
              maxLength={20}
            />
            {isShowPassword.isShow ? (
              <S.ShowIcon onClick={onClickPasswordIcon} />
            ) : (
              <S.HiddenIcon onClick={onClickPasswordIcon} />
            )}
          </S.PasswordContainer>
        </S.InputContainer>

        <S.SaveContainer>
          <S.CheckBox
            type="checkbox"
            checked={login.isUserIdStored}
            onChange={handleCheckbox}
          />
          ID 저장
          <S.CheckBox type="checkbox" />
          자동로그인
        </S.SaveContainer>

        <S.LoginButtonContainer>
          <button onClick={onClickLogin}>로그인</button>
        </S.LoginButtonContainer>

        <S.BottomContainer>
          <S.JHCIcon>
            <img src="logo.png" style={{ height: "40px" }} alt="logo" />
          </S.JHCIcon>
          Copyright © JHC 2021
        </S.BottomContainer>
      </S.LoginContainer>
    </S.Container>
  );
}

export default Login;
